import './FooterBottom.scss'

function FooterBottom () {
  return (
    <div className='footer_bottom'>
      <div className='div_bottom'>
        <p className='footer_copyright'>
          COPYRIGHT © <span className='copyright_year'>2025</span> QK88BET ALL RIGHTS
          RESERVED
        </p>
      </div>
    </div>
  )
}

export default FooterBottom
